// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
// import '@/config/rem' // 配置flex
import 'normalize.css' // 重置样式表
// import '@/styles/element-ui-style.css' // 重置样式表
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import Antd from 'ant-design-vue';
import './../theme/index.css';
import 'ant-design-vue/dist/antd.less';
import win_adaptive from './util/adaptive.js'
import qs from 'qs'
import '@/icons' // icon
import moment from 'moment';
import 'moment/locale/zh-cn';
import VueAwesomeSwiper from 'vue-awesome-swiper';
import "swiper/dist/css/swiper.css";
moment.locale('zh-cn');

import BaiduMap from 'vue-baidu-map'

Vue.use(BaiduMap, {
  // ak 是在百度地图开发者平台申请的密钥 
  ak: 'rC9yL0xHNtDA7cBaXGaSVeyxLqUmtAyA'
})
//屏幕适配
setTimeout(() => {
  win_adaptive();
  if (navigator.userAgent.indexOf("Firefox") > 0) {
    function changeDom() {
      let clientTop = document.documentElement.clientHeight / 2 - 140
      if (clientTop < 200) {
        clientTop = 200
      }
      let dom = document.getElementsByClassName('fixed-help-box')[0]
      let scale = Number(document.getElementById('app').getAttribute('style').substr(5, 10).split(';')[0])
      let scrollTop = document.documentElement.scrollTop / scale;
      let offsetHeight = document.getElementById('app').offsetHeight
      if (clientTop + scrollTop + 300 > offsetHeight) {
        return
      }
      dom.setAttribute('style', `top:${clientTop+scrollTop}px;margin-top:0;`);
    }
    changeDom()
    window.addEventListener('scroll', function () {
      changeDom()
    });
  }
}, 200)

window.addEventListener('resize', function () {
  win_adaptive();
});


Vue.use(ElementUI);
Vue.use(Antd);
Vue.use(VueAwesomeSwiper)
Vue.prototype.$message = ElementUI.Message
Vue.prototype.$qs = qs
// 阻止启动生产消息
Vue.config.productionTip = false

Vue.filter('money', function (value) {
  if (!value) return '0.00'
  var val = value.toFixed(2)
  var intPart = Number(val).toFixed(0)
  var intPartFormat = intPart.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,')
  var floatPart = '.00'
  val = value.toString()
  var value2Array = value.split('.')
  if (value2Array.length === 2) {
    floatPart = value2Array[1].toString()
    if (floatPart.length === 1) {
      return intPartFormat + '.' + floatPart + '0'
    } else {
      return intPartFormat + '.' + floatPart
    }
  } else {
    return intPartFormat + floatPart
  }
})
// 支付方式
Vue.filter('paymentModeFormat', function (value) {
  if (!value) {
    return value
  }
  switch (Number(value)) {
    case 1:
      return '在线支付';
    case 2:
      return '在线支付';
    case 3:
      return '转账汇款';
    case 4:
      return '账期支付';
    case 5:
      return '面对面交易';
    case 6:
      return '工行支付';
    case 7:
      return 'e企付';
    default:
      return '面对面交易';
  }
})
// 防止连点
Vue.directive('throttle', {
  inserted(el, binding) {
    el.addEventListener('click', () => {
      el.style.pointerEvents = 'none'
      if (!el.disabled) {
        setTimeout(() => {
          el.style.pointerEvents = 'auto'
        }, binding.value || 2000)
      }
    })
  }
})

Vue.prototype.openLoading = function () {
  const loading = this.$loading({ // 声明一个loading对象
    lock: true, // 是否锁屏
    target: '.sub-main', // 需要遮罩的区域
    body: true,
    background: '#ffffff',
    customClass: 'mask' // 遮罩层新增类名
  })
  setTimeout(function () { // 设定定时器，超时5S后自动关闭遮罩层，避免请求失败时，遮罩层一直存在的问题
    loading.close() // 关闭遮罩层
  }, 5000)
  return loading
}
router.afterEach((to, from, next) => {
  window.scrollTo(0, 0)
})
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: {
    App
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js